import React, { useState, useEffect } from 'react';
import axios from 'axios';
import BottomNav from '../../components/BottomNav';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Rewards = () => {
  const [rewards, setRewards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRewards();
  }, []);

  const fetchRewards = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/consumer/rewards`, {
        withCredentials: true
      });
      setRewards(data.rewards);
    } catch (error) {
      toast.error('Failed to load rewards');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#18261E]">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-gray-300 border-r-transparent"></div>
          <p className="mt-4 text-[#889990]">Loading rewards...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#18261E] pb-24">
      {/* Header */}
      <div className="bg-[#283D32]/80 backdrop-blur-xl border-b border-[#3E5248] px-6 py-6">
        <h1 className="text-3xl tracking-tight text-white" data-testid="rewards-title">Your Rewards</h1>
        <p className="text-[#889990] mt-2">Redeem at participating merchants</p>
      </div>

      <div className="px-6 py-8">
        {rewards.length === 0 ? (
          <div className="text-center py-12 bg-[#283D32]/50 backdrop-blur-sm border border-[#3E5248] rounded-2xl" data-testid="no-rewards-message">
            <div className="text-5xl mb-4">🏆</div>
            <p className="text-white font-medium mb-2">No rewards yet</p>
            <p className="text-sm text-[#889990]">Keep visiting your favorite spots to earn rewards</p>
          </div>
        ) : (
          <div className="space-y-4">
            {rewards.map((reward, index) => (
              <div
                key={reward.id}
                className="bg-[#283D32]/50 backdrop-blur-sm border border-[#3E5248] rounded-2xl p-6"
                data-testid={`reward-card-${index}`}
              >
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="text-lg font-medium text-white" data-testid={`reward-merchant-name-${index}`}>{reward.merchant_name}</h3>
                    <p className="text-[#E8EBE9] font-medium mt-1" data-testid={`reward-description-${index}`}>{reward.reward_description}</p>
                  </div>
                  {reward.merchant_logo && (
                    <img src={reward.merchant_logo} alt={reward.merchant_name} className="w-12 h-12 rounded-full object-cover" />
                  )}
                </div>
                
                <div className="bg-[#344840]/50 rounded-xl p-4 mt-4 border border-[#3E5248]">
                  <p className="text-sm text-gray-200">
                    <span className="font-medium text-[#C3A365]">Ready to redeem!</span> Show this to the merchant.
                  </p>
                  <p className="text-xs text-[#889990] mt-2" data-testid={`reward-visits-${index}`}>
                    {reward.visits} visits completed
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <BottomNav />
    </div>
  );
};

export default Rewards;
